import Controller from '@ember/controller';
import ObjectModel from 'cio/models/object';
import { tracked } from '@glimmer/tracking';
import config from 'cio/config/environment';
import { later } from '@ember/runloop';

export default class ObjectRelationshipsController extends Controller {
  declare model: ObjectModel;

  @tracked reloadingRelationshipTable = false;

  get objectTypeId() {
    return this.model.belongsTo('objectType').id() || null;
  }

  reloadRelationshipsTable() {
    this.reloadingRelationshipTable = true;
    later(() => {
      this.reloadingRelationshipTable = false;
    }, config.APP.relationshipsChangedDelay);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'object.relationships': ObjectRelationshipsController;
  }
}
